export default __webpack_public_path__ + "static/media/Group 6491.88db25bc.svg";